import React from "react";
import { useLanguage } from "../utils/i18n";

export default function Header({ onSignOut, onHome, onOpenProfile, userInitial }) {
  const { lang, toggleLang, t } = useLanguage();
  return (
    <header className="app-header">
      <div className="header-logo" onClick={onHome} style={{ cursor: "pointer" }}>
        <span className="header-logo-name"><span style={{ color: "#a78bfa" }}>NOTE</span><span style={{ color: "#ff69b4" }}>MILA</span></span>
      </div>
      <div className="header-actions">
        <button
          onClick={toggleLang}
          className="lang-pill-toggle"
          title="Switch language / 切换语言"
        >
          <span className={lang === "en" ? "lang-pill-option active" : "lang-pill-option"}>EN</span>
          <span className="lang-pill-divider">|</span>
          <span className={lang === "zh" ? "lang-pill-option active" : "lang-pill-option"}>中</span>
        </button>
        {onOpenProfile && (
          <button
            className="profile-header-btn"
            onClick={onOpenProfile}
            title={t("myProfile")}
            aria-label={t("myProfile")}
          >
            {userInitial || "?"}
          </button>
        )}
      </div>
    </header>
  );
}
